import { useThemeStore } from '../state/theme';
import { BtnDefault } from './common/Buttons';
import { LoadingSpinner, NotFound } from '../Icons';

interface LoadingErrorStateProps {
  isLoading: boolean;
  isFetching: boolean;
  error: unknown;
  refetch?: () => void;
  data?: any;
}

export const LoadingErrorState = ({
  isLoading,
  isFetching,
  error,
  refetch,
  data,
}: LoadingErrorStateProps) => {
  const { isDarkMode } = useThemeStore();

  if (isLoading) {
    return (
      <div
        className={`pt-2 gap-2 flex items-center h-full justify-center ${isDarkMode ? 'text-gray-200' : 'text-gray-800'}`}
      >
        <div
          className={`flex flex-col gap-2 text-md items-center justify-center py-8 px-16 ${isDarkMode ? 'bg-gray-800' : 'bg-white border border-gray-200'} rounded-lg`}
        >
          <LoadingSpinner className="w-8 h-8" /> Loading data...
        </div>
      </div>
    );
  }

  if (isFetching) {
    return (
      <div
        className={`pt-2 gap-2 flex items-center h-full justify-center ${isDarkMode ? 'text-gray-200' : 'text-gray-800'}`}
      >
        <div
          className={`flex flex-col gap-2 text-md items-center justify-center py-8 px-16 ${isDarkMode ? 'bg-gray-800' : 'bg-white border border-gray-200'} rounded-lg`}
        >
          <LoadingSpinner className="w-8 h-8" /> Fetching data...
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div
        className={`pt-2 gap-2 flex items-center h-full justify-center ${isDarkMode ? 'text-gray-200' : 'text-gray-800'}`}
      >
        <div
          className={`flex flex-col gap-2 text-md items-center justify-center py-8 px-16 ${isDarkMode ? 'bg-gray-800' : 'bg-white border border-gray-200'} rounded-lg`}
        >
          Error loading data
          {refetch && (
            <BtnDefault onClick={() => refetch()} className="px-4 text-sm py-2">
              Retry
            </BtnDefault>
          )}
        </div>
      </div>
    );
  }

  if (!data) {
    return (
      <div
        className={`pt-2 gap-2 flex items-center h-full justify-center ${isDarkMode ? 'text-gray-200' : 'text-gray-800'}`}
      >
        <div
          className={`flex flex-col gap-2 text-md items-center justify-center py-8 px-16 ${isDarkMode ? 'bg-gray-800' : 'bg-white border border-gray-200'} rounded-lg`}
        >
          <NotFound className="w-12 h-12" /> No data found
        </div>
      </div>
    );
  }

  return null;
};
